import styled from "@emotion/styled";
import React from "react";
import PropTypes from "prop-types";
import Checkbox from '@material-ui/core/Checkbox';
import TranslateTransition from "../animations/TranslateTransition";
import TableRowComponent from "./TableRowComponent";

const CustomerRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 42px repeat(auto-fill, 276px);
    grid-column-start: 1;
    grid-column-end: 5;
    align-items: center;
`;

export const TableCell = styled.span``;

const CustomerRowHeading = styled.h3`
    font-size: var(--font-m);
    color: var(--font-secondary);
    font-weight: 300;
    text-align: center;
    width: fit-content;
    margin: 15px;
`;

export default function TableRowGroupsComponent({groupHeading, tableHeadings, rows, selectedRows, onCheckBoxSelected, hasCheckBoxes}) {
    return (
        <>
            <CustomerRowHeading>{groupHeading}</CustomerRowHeading>
            {
                rows.map((rowData, index) =>
                    <TableRowComponent key={index}
                                       isSelected={selectedRows.includes(rowData && rowData.id)}
                                       onCheckBoxSelected={onCheckBoxSelected}
                                       hasCheckBox={hasCheckBoxes}
                                       tableHeadings={tableHeadings}
                                       rowData={rowData}
                    />
                )
            }
        </>
    )
}

TableRowGroupsComponent.propTypes = {
    rowHeading: PropTypes.string,
    columnHeaders: PropTypes.array,
    groupHeading: PropTypes.string,
    rowData: PropTypes.array,
    isSelected: PropTypes.bool,
    onCheckBoxSelected: PropTypes.func
};

TableRowGroupsComponent.defaultProps = {
    rowData: []
};
